// extracted by mini-css-extract-plugin
export default {"grid":"DocumentsPage_grid__sjNAj"};